import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ResetPassword from './pages/ResetPassword';
import Contact from './pages/Contact';
import ImageGenerator from './pages/ImageGenerator';
import VerifyEmail from './pages/VerifyEmail';
import Pricing from './pages/Pricing';
import PaymentSuccess from './pages/PaymentSuccess';
import Profile from './pages/Profile';
import Success from './pages/Success';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00ffea', // Cyan/turquoise color similar to the image
      contrastText: '#000'
    },
    secondary: {
      main: '#ff00ff', // Magenta for accents
      contrastText: '#000'
    },
    background: {
      default: '#0a0b0e', // Very dark blue-black
      paper: '#141519', // Slightly lighter dark for cards/papers
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    }
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(20, 21, 25, 0.8)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
        },
        contained: {
          background: 'linear-gradient(45deg, #00ffea 30%, #00b8ff 90%)',
          color: '#000',
          '&:hover': {
            background: 'linear-gradient(45deg, #00b8ff 30%, #00ffea 90%)',
          }
        },
        outlined: {
          color: '#fff',
          borderColor: 'rgba(255, 255, 255, 0.5)',
          '&:hover': {
            borderColor: '#fff',
          }
        },
        text: {
          color: '#fff',
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderRadius: '12px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        }
      }
    }
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    }
  },
  shape: {
    borderRadius: 12
  }
});

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="background-orb orb-1" />
        <div className="background-orb orb-2" />
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/contact" element={<Contact />} />
            <Route 
              path="/image-generator" 
              element={
                <ProtectedRoute>
                  <ImageGenerator />
                </ProtectedRoute>
              } 
            />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route path="/success" element={<ProtectedRoute><Success /></ProtectedRoute>} />
          </Routes>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App; 